import { render, staticRenderFns } from "./ConfirmarAcesso.vue?vue&type=template&id=696bb4a2&"
import script from "./ConfirmarAcesso.vue?vue&type=script&lang=js&"
export * from "./ConfirmarAcesso.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmarAcesso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports